import { render, staticRenderFns } from "./AgentData.vue?vue&type=template&id=642ed4ab"
import script from "./AgentData.vue?vue&type=script&lang=js"
export * from "./AgentData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports